import { BFF_ENDPOINT } from './Defaults';
import { getVnSecret } from '../utility/utils';

class DocumentTypesAPI {

  static fetchDocumentTypes = workflowInstanceId =>
    new Promise((resolve, reject) => {
      fetch(`${BFF_ENDPOINT}/api/v1/workflow/${workflowInstanceId}/document-type`, {
        type: 'GET',
        headers: {
          vnSecret: getVnSecret()
        },
      })
      .then(res => {
        if (res.ok)
          res.json().then(resolve);
        else {
          res.json()
            .then(reject)
            .catch(() => reject())
        }
      })
      .catch(reject);
    });

}

export default DocumentTypesAPI;



// WEBPACK FOOTER //
// ./src/integrations/DocumentTypesAPI.js